import { EntityWithStatusService } from './EntityWithStatusService';
import { IEntityChildren, IEntityDescription1, IRiskAppIssue } from '../types';
import { EntityStatus } from '../refData/EntityStatus';
import { AppGlobals } from '../AppGlobals';

export class RiskAppIssueService extends EntityWithStatusService<IRiskAppIssue> {
    public readonly parentEntities = ['ManagedByL2', 'ManagedByL3'];
    protected childrenEntities = ['Contributors($expand=ContributorUser)', 'CustomFields($expand=CustomFieldDfn)'];

    constructor() {
        super(`/RiskAppIssues`);
    }



    public readAllForLookup(includeClosed?: boolean): Promise<IRiskAppIssue[]> {
        return this.readAll(
            `?$select=ID,Title`
            + `&$orderby=Title&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            + (includeClosed ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
        );
    }

    public readAllForList(includeClosed?: boolean): Promise<IRiskAppIssue[]> {
        return this.readAll(
            `?$select=ID,Title,OwnerTypeID,ManagedByTypeID,DateIdentified,TargetResolutionDate`
            + `&$orderby=Title`
            + `&$expand=Source($select=Title),Priority($select=Title),Stage($select=Title),OwnerL1($select=Title),OwnerL2($select=Title),OwnerL3($select=Title),ManagedByL2($select=Title),ManagedByL3($select=Title),EntityStatus($select=Title),IssueManager($select=Title),Contributors($expand=ContributorUser($select=Title)),RiskAppIssueActions($select=ID)`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            + (includeClosed ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
        );
    }

    public async readTitleForCorrectiveActions(entityPlural: string, entitySingular: string, issueID: number): Promise<IEntityDescription1> {
        const entityDescription1: IEntityDescription1 = {
            DescriptionLine1: '',
            DescriptionLine2: '',
            Description1ForList: '',
            Description1ForForm: ''
        };
        const res = await this.readAll(`?$filter=ID eq ${issueID}&$select=Title`);
        if (res.length > 0) {
            entityDescription1.DescriptionLine1 = `${entityPlural} for issue`;
            entityDescription1.DescriptionLine2 = res[0].Title;
            entityDescription1.Description1ForList = `${entityPlural} for issue <span style='font-style: italic'>${res[0].Title}</span>`;
            entityDescription1.Description1ForForm = `${entitySingular} for issue <span style='font-style: italic'>${res[0].Title}</span>`;
        }

        return entityDescription1;
    }

    public async entityChildren_(id: number): Promise<IEntityChildren[]> {
        return this.entityChildrenSingle(id, 'Corrective Actions', 'RiskAppIssueActions', true);
    }

    public async entityChildren(id: number): Promise<IEntityChildren[]> {
        const entityUrl = `${this.entityUrl}(${id})`;
        const actions = (await this.axiosGet(`${entityUrl}/RiskAppIssueActions?$select=ID&$top=10`)).data.value;
        const evidences = (await this.axiosGet(`${entityUrl}/RiskAppEvidences?$select=ID&$top=10`)).data.value;
        return [
            { ChildType: 'Corrective Actions', CanBeAdopted: false, ChildIDs: (await actions).map((m: { ID: any }) => m.ID) },
            { ChildType: 'Comments and File Attachments', CanBeAdopted: false, ChildIDs: (await evidences).map((w: { ID: any }) => w.ID) }
        ];
    }

}